import React from 'react';
import CalibrationCompanyProgressiveList from './CalibrationCompanyProgressiveList';
import { CALIBRATION_COMPANY_LIST_MASKS } from '../../../utils/calibrationCompanyListMasks';

export default function CalibrationCompanyCardList(props) {
  return <CalibrationCompanyProgressiveList mask={CALIBRATION_COMPANY_LIST_MASKS.cards} {...props} />;
}
